import * as React from 'react';
import { SVGProps } from 'react';

const IconBackwardSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m5.407 7 3.297-3.297L7.29 2.289 1.579 8l5.711 5.711 1.414-1.414L5.407 9H14V7H5.407z" />
  </svg>
);
export default IconBackwardSizeS;
